import DeleteIcon from '@mui/icons-material/Delete'
import { Stack } from '@mui/joy'
import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { useRole, useStatus } from '~/entities/common/Balance/Appeal'
import { usePermissions } from '~/entities/common/viewer'
import { Button } from '~/shared/ui/Buttons'
import { DownloadIcon, UploadWhiteIcon } from '~/shared/ui/Icons'
import { AuditsModal } from '~/widgets/common/AuditsModal'
import { appealDelete, appealDeleteFx } from './model'

type ActionButtonsProps = {
  appealId: UniqueId
}

export function ActionButtons({ appealId }: ActionButtonsProps) {
  const { t } = useTranslation()

  const { canAuditsView } = usePermissions()
  const isDeletePending = useStore(appealDeleteFx.pending)

  const { isInitiator, isResponsible } = useRole()
  const { isNew, isRejected } = useStatus()

  const canEdit = isNew && isInitiator
  const canTransactionCreate = !isRejected && isResponsible

  return (
    <Stack direction='row' spacing={1}>
      {canAuditsView && <AuditsModal auditableId={appealId} />}

      <Button
        show={canTransactionCreate}
        to='new-spending'
        variant='red'
        startDecorator={<UploadWhiteIcon />}
      >
        {t('button.write off')}
      </Button>
      <Button
        show={canTransactionCreate}
        to='new-coming'
        variant='green'
        startDecorator={<DownloadIcon />}
      >
        {t('button.replenish')}
      </Button>
      <Button
        variant='red'
        startDecorator={<DeleteIcon />}
        onClick={() => appealDelete()}
        loading={isDeletePending}
        show={canEdit}
      >
        {t('button.delete')}
      </Button>
    </Stack>
  )
}
